module.exports = __webpack_public_path__ + "static/TruenoRg-da0e9743dfddc36c46601b5412ec8a86.woff2";